import React from "react";
import { Link } from "react-router-dom";
import classes from "./Footer.module.scss";
import { isBrowser } from "react-device-detect";
import { gaTracker } from "../../../helper/Helper";
import { LoadingSimple } from "../../UI/LoadingBar";
import { FormattedMessage } from "react-intl";

const [paramCategory, paramAction, paramLabel] = [
  "LinkText",
  "JBFS IG",
  "@japfabestfoodsolutions",
];

const FooterApp = (props) => {
  // console.log('[FooterApp.js]');

  const setLocalMetaTitle = (paramTitle) => {
    localStorage.setItem("selected_page_title", paramTitle);
  };

  let japfaAddress = <p>No Content</p>;
  let japfaEmail = <p>No Content</p>;
  let prodCategories = <p>No Product Category Found</p>;
  if (props.prodCategory !== undefined) {
    prodCategories = props.prodCategory.map((item, index) => {
      return (
        <div
          className={classes.AppFooter_productCategory}
          key={`${item.id}${index}`}
        >
          <span
            onClick={() =>
              props.goRefresh(item.slug, item.id, 0, 0, item.name, item.title)
            }
          >
            {item.name}
          </span>
        </div>
      );
    });

    japfaAddress = null;
    if (props.settings.address !== undefined) {
      // japfaAddress = (<div dangerouslySetInnerHTML={{__html: props.settings.address.replace(/(<([^>]+)>)/ig, "")}}/>);
      japfaAddress = (
        <div
          className={classes.Address_div}
          dangerouslySetInnerHTML={{ __html: props.settings.address }}
        />
      );
    }

    const mailto = "mailto:" + props.settings.email + "?subject=JBFS Info";
    japfaEmail = (
      <div>
        <i className="fas fa-envelope" />
        &nbsp;<a href={mailto}>{props.settings.email}</a>
      </div>
    );
  }

  // let liFacebook = <LoadingSimple />;
  // if (props.done) {
  //   liFacebook = (
  //     <li onClick={() => gaTracker(paramCategory, paramAction, paramLabel)}>
  //       <a
  //         href={
  //           props.settings.facebook
  //             ? "//" + props.settings.facebook.replace(/(^\w+:|^)\/\//, "")
  //             : ""
  //         }
  //         target="_blank"
  //         rel="noopener noreferrer"
  //       >
  //         <img
  //           src={require("../../../assets/sosmed/ico-fb-green.png")}
  //           alt="Jbfs Facebook"
  //         />
  //         {/* &nbsp;@japfabestfoodsolutions */}
  //       </a>
  //     </li>
  //   );
  // }

  // let liTwitter = <LoadingSimple />;
  // if (props.done) {
  //   liTwitter = (
  //     <li onClick={() => gaTracker(paramCategory, paramAction, paramLabel)}>
  //       <a
  //         href={
  //           props.settings.twitter
  //             ? "//" + props.settings.twitter.replace(/(^\w+:|^)\/\//, "")
  //             : ""
  //         }
  //         target="_blank"
  //         rel="noopener noreferrer"
  //       >
  //         <img
  //           src={require("../../../assets/sosmed/ico-twitter-green.png")}
  //           alt="Jbfs Twitter"
  //         />
  //       </a>
  //     </li>
  //   );
  // }

  let liSosmed = <LoadingSimple />;
  if (props.done) {
    liSosmed = (
      <li onClick={() => gaTracker(paramCategory, paramAction, paramLabel)}>
        <a
          // href={
          //   props.settings.instagram
          //     ? "//" + props.settings.instagram.replace(/(^\w+:|^)\/\//, "")
          //     : ""
          // }
          href="https://www.japfacomfeed.co.id"
          // target="_blank"
          // rel="noopener noreferrer"
        >
          {/* <img
            src={require("../../../assets/sosmed/ico-ig-green.png")}
            alt="Japfa Food Instagram"
          />
          &nbsp;@japfafood */}

          <b>www.japfacomfeed.co.id</b>
        </a>
      </li>
    );
  }

  let liLogo = <LoadingSimple />;
  if (props.done) {
    liLogo = (
      <a href="https://www.japfacomfeed.co.id">
        {/* <img src={props.settings.logo} alt="logo" /> */}
        <img
          className={classes.AppFooter_logoContainer}
          src="japfa-logo.png"
          alt="Japfa Comfeed"/>
      </a>
    );
  }

  return (
    <div className={classes.AppFooter_container}>
      <div className={["jbfs-wrapper", classes.AppFooter_wrapper].join(" ")}>
        {!isBrowser || window.innerWidth < 720 ? (
          <React.Fragment>
            <div className="col-6">
              <span className={classes.AppFooter_title}>
                <FormattedMessage
                  id={"global.footer.contactus.title"}
                  defaultMessage={"CONTACT US"}
                />
              </span>
              {!props.done ? (
                <LoadingSimple />
              ) : (
                <div className={classes.AppFooter_linkChild}>
                  {japfaAddress}
                  {/* <div>
                    <i className="fa fa-phone small" />
                    &nbsp;{props.settings.phone_number}
                  </div> */}
                  {japfaEmail}
                </div>
              )}
            </div>
            <div className="col-6">
              <div className={classes.AppFooter_logoContainer}>
                <div>{liLogo}</div>
                <ul className={classes.AppFooter_sosmedContainer}>
                  {liSosmed}
                </ul>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div>
              <span className={classes.AppFooter_title}>
                <FormattedMessage
                  id={"global.footer.productcategory.title"}
                  defaultMessage={"PRODUCT CATEGORY"}
                />
              </span>
              {!props.done ? (
                <LoadingSimple />
              ) : (
                <div className={classes.AppFooter_linkChild}>
                  {prodCategories}
                </div>
              )}
            </div>
            <div>
              <span className={classes.AppFooter_title}>Japfa Food</span>
              <div className={classes.AppFooter_linkChild}>
                <div>
                  <Link to="/about" onClick={() => setLocalMetaTitle("About")}>
                    {/*About JBFS*/}
                    <FormattedMessage
                      id={"global.footer.jbfs.nav1"}
                      defaultMessage={"About JBFS"}
                    />
                  </Link>
                </div>
                <div>
                  <Link
                    to="/menu-ideas"
                    onClick={() => setLocalMetaTitle("Menu Ideas")}
                  >
                    {/*Menu Ideas*/}
                    <FormattedMessage
                      id={"global.footer.jbfs.nav2"}
                      defaultMessage={"Menu Ideas"}
                    />
                  </Link>
                </div>
                <div>
                  <Link
                    to="/news-events"
                    onClick={() => setLocalMetaTitle("News & Events")}
                  >
                    {/*News & Events*/}
                    <FormattedMessage
                      id={"global.footer.jbfs.nav3"}
                      defaultMessage={"News & Events"}
                    />
                  </Link>
                </div>
              </div>
            </div>
            <div className={classes.AppFooter_contactSection}>
              <div className={classes.AppFooter_contactRow}>
                <div>
                  <span className={classes.AppFooter_title}>
                    <FormattedMessage
                      id={"global.footer.contactus.title"}
                      defaultMessage={"CONTACT US"}
                    />
                  </span>
                  {!props.done ? (
                    <LoadingSimple />
                  ) : (
                    <div className={classes.AppFooter_linkChild}>
                      {japfaAddress}
                    </div>
                  )}
                </div>
                <div>
                  <div className={classes.AppFooter_logoContainer}>
                    <div className={classes.AppFooter_memberContainer}>Member of <b>JAPFA</b></div>
                    <div>{liLogo}</div>
                    <ul className={classes.AppFooter_sosmedContainer}>
                      {/* {liFacebook}
                      {liTwitter} */}
                      {liSosmed}
                    </ul>
                  </div>
                </div>
              </div>
              <div className={classes.AppFooter_contactRow}>
                <div className={classes.AppFooter_linkChild}>
                  <div className={classes.AppFooter_csDivider}>
                    <span>
                      <FormattedMessage
                        id={"global.footer.contactus.csTitle"}
                        defaultMessage={"HUBUNGI KAMI"}
                      />
                    </span>
                  </div>
                </div>
              </div>
              <div className={classes.AppFooter_contactRow}>
                <div className={classes.AppFooter_linkChild}>
                  <div className={classes.AppFooter_csGroupTitle}>
                    <FormattedMessage
                      id={"global.footer.contactus.partnerTitle"}
                      defaultMessage={"LAYANAN MITRA USAHA"}
                    />
                  </div>
                  <div className={classes.AppFooter_csItems}>
                    <div className={classes.AppFooter_csItem}>
                      <i className="fab fa-whatsapp" />
                      <div className={classes.AppFooter_csText}>
                        <span className={classes.AppFooter_csLabel}>
                          <FormattedMessage
                            id={"global.footer.contactus.csSales"}
                            defaultMessage={"CUSTOMER SERVICE"}
                          />
                        </span>
                        <a href="https://wa.me/6281188880811">0811-8888-0811</a>
                      </div>
                    </div>
                    <div className={classes.AppFooter_csItem}>
                      <i className="fab fa-whatsapp" />
                      <div className={classes.AppFooter_csText}>
                        <span className={classes.AppFooter_csLabel}>
                          <FormattedMessage
                            id={"global.footer.contactus.csComplaint"}
                            defaultMessage={"PRODUCT & SALES INQUIRY"}
                          />
                        </span>
                        <a href="https://wa.me/6281190007373"> 0811-9000-7373</a>
                      </div>
                    </div>
                    <div className={classes.AppFooter_csItem}>
                      <i className="fab fa-whatsapp" />
                      <div className={classes.AppFooter_csText}>
                        <span className={classes.AppFooter_csLabel}>
                          <FormattedMessage
                            id={"global.footer.contactus.csComplaint"}
                            defaultMessage={"CUSTOMER COMPLAINT"}
                          />
                        </span>
                        <a href="https://wa.me/6281131195999">0811-3119-5999</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={classes.AppFooter_linkChild}>
                  <div className={classes.AppFooter_csGroupTitle}>
                    <FormattedMessage
                      id={"global.footer.contactus.retailTitle"}
                      defaultMessage={"LAYANAN PELANGGAN RETAIL"}
                    />
                  </div>
                  <div className={classes.AppFooter_csItems}>
                    <div className={classes.AppFooter_csItem}>
                      <i className="fab fa-whatsapp" />
                      <div className={classes.AppFooter_csText}>
                        <span className={classes.AppFooter_csLabel}>
                          <FormattedMessage
                            id={"global.footer.contactus.csService"}
                            defaultMessage={"CUSTOMER SERVICE"}
                          />
                        </span>
                        <a href="https://wa.me/628041509006">0804-150-9006</a>
                      </div>
                    </div>
                  </div>
                  <div className={classes.AppFooter_csPlainDivider} />
                  {japfaEmail}
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  ); //end of return;
}; //end of function components

export default FooterApp;
